'use client';

import { RefObject, useEffect, useRef } from 'react';

/**
 * Ref that reads `true` while the component is mounted. Check `.current` after an `await` to skip
 * work that only makes sense if the component still exists.
 *
 * Returns the ref itself rather than a boolean: a value read during render is captured by async
 * callbacks and never turns `false`, which is why the legacy packages/ui `useIsMounted` never guards
 * anything. The flag is set inside the effect so Strict Mode's mount, unmount and remount ends on
 * `true`.
 */
export function useIsMountedRef(): RefObject<boolean> {
  const isMountedRef = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  return isMountedRef;
}
